<template>
  <div class="slide-gallery">
    <div class="view-ablum" @click="viewAlbum">View Photo</div>
    <VueAgile class="main" ref="main" :options="options" :as-nav-for="asNavFor1">
      <div class="slide" v-for="(slide, index) in images" :key="index" :class="`slide--${index}`">
        <img :src="$processImage(slide.url,{resize:'lg'})" />
        <div class="slide-desc" v-if="slide.name || slide.desp">
          <div class="slide-desc-title" v-if="slide.name">{{slide.name}}</div>
          <div class="slide-desc-desp" v-if="slide.desp"><small>{{slide.desp}}</small></div>
        </div>
      </div>
    </VueAgile>
    <VueAgile class="thumbnails" ref="thumbnails" :options="options2" :as-nav-for="asNavFor2">
      <div class="slide slide--thumbniail" v-for="(slide, index) in images" :key="index" :class="`slide--${index}`" @click="$refs.thumbnails.goTo(index)">
        <img :src="$processImage(slide.url,{resize:'mid'})" alt="">
      </div>
      <!-- <template slot="prevButton"><i class="fas fa-chevron-left"></i></template>
      <template slot="nextButton"><i class="fas fa-chevron-right"></i></template> -->
    </VueAgile>
  </div>
</template>
<script>
import { VueAgile } from 'vue-agile'
import fancyBox from '@fancyapps/fancybox'


export default {
  data() {
    return {
      activeImage: 0,
      asNavFor1: [],
      asNavFor2: [],
      options: {
        dots: false,
        navButtons: false,
      },
      options2: {
        centerMode: true,
        dots: false,
        navButtons: false,
        slidesToShow: 4,
      },
    }
  },
  props: {
    images: Array,
  },
  components: {
    VueAgile
  },
  mounted() {
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
  },
  methods: {
    makeCaption(image) {
      if (image.name && image.desp) {
        return `<p>${image.name}</p><p><small>${image.desp}</small></p>`
      }
      if (image.name && !image.desp) {
        return `<p>${image.name}</p>`
      }
      if (!image.name && image.desp) {
        return `<p><small>${image.desp}</small></p>`
      }
      return ''
    },
    viewAlbum() {
      let images = this.images

      let items = []
      let ref = this.$refs.thumbnails
      images.forEach(image => {
        items.push({
          src: image.url,
          opts: {
            caption: this.makeCaption(image),
            thumb: image.url,
            height: window.innerHeight * 0.6,
            beforeClose(current) {
              ref.goTo(current.currIndex)
            },
          },
        })
      })
      $.fancybox.open(
        // items
        items,
        // options
        {
          loop: true,
          buttons: ['zoom', 'thumbs', 'close'],
        },
        this.$refs.main.getCurrentSlide()
      )
    }
  }
  // watch: {
  //   'images': {
  //     immediate: true,
  //     handler(val) {
  //       console.log(val)
  //       if (val.length) {
  //         this.asNavFor1.push(this.$refs.thumbnails)
  //         this.asNavFor2.push(this.$refs.main)
  //       }

  //     },
  //   }
  // }
}

</script>
<style lang="scss" scoped>
@import '~@fancyapps/fancybox/src/css/core.css';
@import '~@fancyapps/fancybox/src/css/thumbs.css';

.slide-gallery {
  margin-bottom: 30px;
  width: 100%;
  position: relative;

  .view-ablum {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    cursor: pointer;
    padding: 8px 16px;
    top: 20px;
    right: 20px;
    z-index: 3;
    border-radius: 4px;
  }

  .slide {
    position: relative;

    .slide-desc {
      position: absolute;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      width: 100%;
      padding: 14px 10px 10px 10px;

      .slide-desc-title {
        font-size: 16px;
        margin-bottom: 10px;
        z-index: 10;
      }
    }
  }

  // overflow: hidden;
  .main {
    .slide {
      overflow: hidden;
      border: 1px solid rgba(0, 0, 0, .1);
      border-radius: 4px;
    }
  }

  .thumbnails {
    margin: 20px -5px;
    width: calc(100% + 10px);

    .agile__slide--active {
      opacity: 1;
      filter: none;
    }

    .slide {
      img {
        border-radius: 4px;
      }

    }
  }

  .agile__nav-button {
    background: transparent;
    border: none;
    color: #ccc;
    cursor: pointer;
    font-size: 24px;
    transition-duration: 0.3s;
  }

  .thumbnails .agile__nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .thumbnails .agile__nav-button--prev {
    left: -45px;
  }

  .thumbnails .agile__nav-button--next {
    right: -45px;
  }

  .agile__nav-button:hover {
    color: #888;
  }

  .agile__dot {
    margin: 0 10px;
  }

  .agile__dot button {
    background-color: #eee;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: block;
    height: 10px;
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
    transition-duration: 0.3s;
    width: 10px;
  }

  .agile__dot--current button,
  .agile__dot:hover button {
    background-color: #888;
  }

  .slide {
    align-items: center;
    box-sizing: border-box;
    color: #fff;
    display: -webkit-box;
    display: flex;
    height: 450px;
    justify-content: center;
  }

  .slide--thumbniail {
    cursor: pointer;
    height: 100px;
    transition: opacity 0.3s;
    padding: 0 5px;

    // border-radius: 4px;
    // overflow: hidden;
    opacity: 0.7;
    filter: grayscale(100%)
  }

  .slide--thumbniail:hover {}

  .slide img {
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
  }

}

@media (max-width: 767px) {
  .slide-gallery {
    .view-ablum {
      top: 12px;
      right: 12px;
      padding: 7px 12px;
    }

    .slide {
      height: 260px;
    }

    .slide--thumbniail {
      height: 64px;
      padding: 0 4px;
    }

    .thumbnails {
      margin: 10px -4px;
      width: calc(100% + 8px);
    }
  }
}

</style>
